import { Paper as MuiPaper, ToggleButtonGroup, toggleButtonGroupClasses } from '@mui/material'
import styled from '@emotion/styled/macro'
import { styled as muiStyled } from '@mui/material/styles'
import theme from 'theme'

export const Paper = styled(MuiPaper, {
  shouldForwardProp: (prop) => prop !== 'activeView'
})<{ activeView: 'current' | 'trend' }>`
  display: flex;
  flex-wrap: wrap;
  background-color: ${theme.colors.btnSecondaryHoverBg};
  border-radius: 14px;

  html[data-theme='light'] & {
    background-color: #ededf0;
  }

  & .MuiToggleButtonGroup-root {
    padding: 2px;
    gap: 2px;
    min-width: unset !important;
    min-height: unset !important;
    max-width: unset !important;
    max-height: unset !important;
    background: ${theme.colors.btnSecondaryHoverBg};
    border-radius: 14px;

    html[data-theme='light'] & {
      background: #ededf0;
    }

    & .MuiToggleButton-root {
      width: 48px;
      height: 48px;
      min-width: unset !important;
      min-height: unset !important;
      max-width: unset !important;
      max-height: unset !important;
      margin-left: 0;
      border: 1px solid transparent;
      border-radius: 12px;
      text-transform: none;

      & .MuiTypography-root {
        color: ${theme.colors.calendarDay};
        text-align: center;
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.large};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.bold};
        line-height: 20px;
        letter-spacing: 0.1px;

        &.active {
          color: ${theme.colors.cta};
        }
      }

      &:first-of-type {
        &:hover {
          background: ${({ activeView }) => (activeView === 'current' ? theme.colors.legacy4e444b : '')};

          svg {
            path {
              fill: ${theme.colors.cta};
              stroke: ${theme.colors.cta};
            }
          }
        }
      }

      &:last-of-type {
        &:hover {
          background: ${({ activeView }) => (activeView === 'trend' ? theme.colors.legacy4e444b : '')};

          svg {
            path {
              stroke: ${({ activeView }) => (activeView === 'trend' ? '' : theme.colors.cta)};
            }
          }
        }
      }
    }
  }
`

export const StyledToggleButtonGroup = muiStyled(ToggleButtonGroup)(() => ({
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    margin: 0,
    border: 0,
    borderRadius: '12px !important',

    [`&:not(:first-of-type)`]: {
      borderRadius: '12px !important'
    },

    [`&:not(:last-of-type)`]: {
      borderRadius: '12px !important'
    },

    [`&.${toggleButtonGroupClasses.disabled}`]: {
      border: 0
    }
  }
}))
